import { render } from "./UserProfilePage.vue?vue&type=template&id=bada91b2&scoped=true&ts=true"
import script from "./UserProfilePage.vue?vue&type=script&lang=ts"
export * from "./UserProfilePage.vue?vue&type=script&lang=ts"

import "./UserProfilePage.vue?vue&type=style&index=0&id=bada91b2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bada91b2"]])

export default __exports__